import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FurnitureCategoryService {

  constructor(
    private http : HttpClient
  ) { }

    getAll(searchParams){
      return this.http.get(`${environment.stanthonyUrl}/furniture/category`,{params:searchParams});
    }

    get(Id){
      return this.http.get(`${environment.stanthonyUrl}/furniture/category/`+Id);
    }

    edit(Id,formData){
      return this.http.put(`${environment.stanthonyUrl}/furniture/category/`+Id,formData);
    }

    create(formData){
      return this.http.post(`${environment.stanthonyUrl}/furniture/category`,formData);
    }

    delete(Id){
      return this.http.delete(`${environment.stanthonyUrl}/furniture/category/`+Id);
    }

}
